<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">新增</el-button>
      <el-input
        v-model="listQuery.name"
        placeholder="请输入供应商名"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-select
        v-model="listQuery.forbidden"
        placeholder="是否冻结"
        :clearable="true"
        style="width: 110px"
        class="filter-item"
      >
        <el-option label="正常" value="0" />
        <el-option label="冻结" value="1" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column label="账号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.username }}</template>
      </el-table-column>
      <el-table-column label="供应商名称" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <!-- <el-table-column label="所在地" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.district.name }}</template>
      </el-table-column> -->
      <el-table-column label="详细地址" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.address }}</template>
      </el-table-column>
      <el-table-column label="联系人" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.contact_name }}</template>
      </el-table-column>
      <el-table-column label="联系人电话" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.contact_phone }}</template>
      </el-table-column>
      <el-table-column label="客服电话" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.service_phone }}</template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="添加时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.forbidden == 0" type="success">正常</el-tag>
          <el-tag v-else type="danger">已冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row.id)">修改</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="forbidden(scope.row.id)"
            v-if="scope.row.forbidden == 1"
          >解冻</el-button>
          <el-button size="mini" type="danger" @click="forbidden(scope.row.id)" v-else>冻结</el-button>
          <el-button size="mini" type="warning" @click="resetPassword(scope.row.id)">初始化密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

   
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import * as qiniu from "qiniu-js";
import AMapPosition from "@/components/AMapPosition";

export default {
  components: {
    "img-crop-upload": imgCropUpload,
    "amap-position": AMapPosition,
    uploadList
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
     
      listQuery: {
        name: "",
        forbidden: "",
        page: 1,
        limit: 10
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: "",
        name: "",
        username: "",
        password: "123456",
        province_id: "",
        city_id: "",
        district_id: "",
        contact_name: "",
        contact_phone: "",
        address: "",
        latitude: "",
        longitude: ""
      },
      rules: {
        img: [{ required: true, message: "图片不能为空", trigger: "blur" }]
      },
      btnLoading: false,

      show: false,
      imgBase64Data: "" // the datebase64 url of created image
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/shop",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    search(){
this.listQuery.page = 1;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
        username: "",
        password: "123456",
        province_id: "",
        city_id: "",
        district_id: "",
        contact_name: "",
        contact_phone: "",
        address: "",
        latitude: "",
        longitude: ""
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.$router.push('/shopStore');
      // this.resetForm();
      // this.getProvinceList();

      // this.dialogStatus = "create";
      // this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
    },
    handleUpdate(id) {
      this.$router.push('/shopStore?id='+id);
      // this.getCityList();
      // this.getDistrictsList();
      // this.resetForm();
      // this.form = Object.assign({password:""}, row); // copy obj
      // this.form.province_id = row.province_id.toString();
      // this.form.city_id = row.city_id.toString();
      // this.form.district_id = row.district_id.toString();
      // this.dialogStatus = "update";
      // this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
    },
    
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/banner/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log("-------- 裁剪成功 --------");
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, "tmp.png");
        let key = guid() + ".png";
        let token = response.data.token;
        let baseUrl = response.data.baseUrl;
        let putExtra = {};
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config);
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + "/" + key;
            that.form.img = imgUrl;
            console.log(imgUrl);
          }
        }); // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      });
    },
    forbidden(id) {
      request({
        url: "/api/backend/shop/forbidden",
        method: "post",
        params: { id: id }
      }).then(response => {
        this.getList();
      });
    },
    resetPassword(id) {
      request({
        url: "/api/backend/shop/resetPassword",
        method: "post",
        params: { shop_id: id }
      }).then(response => {
        this.getList();
        this.$message({
          type: "success",
          message: "初始化密码成功!"
        });
      });
    },
  
    getProvinceList() {
      request({
        url: "/api/common/area/index",
        method: "get",
        params: ""
      }).then(response => {
        this.provinceList = response.data;
      });
    },
    getCityList(type) {
      if (type == 1) {
        this.form.city_id = "";
        this.form.district_id = "";
      }
      request({
        url: "/api/common/area/cities",
        method: "get",
        params: { province_id: this.form.province_id }
      }).then(response => {
        this.cityList = response.data;
      });
    },
    getDistrictsList() {
      request({
        url: "/api/common/area/districts",
        method: "get",
        params: { city_id: this.form.city_id }
      }).then(response => {
        this.districtList = response.data;
      });
    }
  }
};
</script>


<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
